import Lenis from "lenis";

let lenis = null;

export function startLenis() {
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  let id;
  const raf = (t) => {
    lenis?.raf(t);
    id = requestAnimationFrame(raf);
  };
  id = requestAnimationFrame(raf);
  return () => {
    cancelAnimationFrame(id);
    lenis?.destroy();
    lenis = null;
  };
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -100, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}
